import React from 'react';
import { styled as styled2 } from '@compiled/react';
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import CheckIcon from '@atlaskit/icon/glyph/check';
import { token } from '@atlaskit/tokens';
import { ff } from '@atlassian/jira-feature-flagging';
import { useIntl } from '@atlassian/jira-intl';
import { MAX_ITEMS_PER_PAGE } from '../../../../common/constants/tab-content';
import TabFooter from '../../../../common/ui/tab-footer';
import {
	ButtonWithAnalytics,
	LinkWithAnalytics as CommonLink,
} from '../../../../common/ui/with-analytics';
import messages from './messages';

export type Props = {
	maxItems: number;
	totalItemCount: number;
	onLoadMoreClick?: () => void;
};

const LinkToGlobalIssueNavigation = ({ children }: React.PropsWithChildren<{}>) => (
	<LinkWithAnalytics
		appearance="link"
		href="/issues/?jql=order+by+created+DESC"
		actionSubjectId="globalIssueNavigationButton"
		buttonLink={ff('nin.global-scope_aqec8') ? true : undefined}
	>
		{children}
	</LinkWithAnalytics>
);
export const RecentlyViewedTabFooter = (props: Props) => {
	const { maxItems, onLoadMoreClick, totalItemCount } = props;

	const { formatMessage } = useIntl();

	const allItemsLoadedText = formatMessage(messages.allItemsLoadedViewAllIssues, {
		a: (chunks: React.ReactNode[]) => (
			<LinkToGlobalIssueNavigation>{chunks}</LinkToGlobalIssueNavigation>
		),
	});

	if (totalItemCount <= MAX_ITEMS_PER_PAGE) {
		return <TabFooter>{allItemsLoadedText}</TabFooter>;
	}
	if (totalItemCount > maxItems && onLoadMoreClick) {
		return (
			<TabFooter>
				<ButtonWithAnalytics
					actionSubjectId="recentlyViewedLoadMoreButton"
					onClick={onLoadMoreClick}
				>
					{formatMessage(messages.loadMore)}
				</ButtonWithAnalytics>
			</TabFooter>
		);
	}
	return (
		<TabFooter>
			<IconWrapper>
				<CheckIcon size="medium" label="" />
			</IconWrapper>
			{allItemsLoadedText}
		</TabFooter>
	);
};

RecentlyViewedTabFooter.defaultProps = {
	onLoadMoreClick: undefined,
};

export default RecentlyViewedTabFooter;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IconWrapper = styled2.div({
	display: 'inline-block',
	position: 'relative',
	top: token('space.050', '4px'),
});

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LinkWithAnalytics = styled(CommonLink)({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
	padding: '0 !important',
	marginTop: token('space.negative.025', '-2px'),
});
